import { useStore } from 'effector-react'
import { $accountForm, $errorCreateAccount, creatAccount } from './model'

export const useCreateAccount = () => {
  const accountForm = useStore($accountForm)
  const loading = useStore(creatAccount.pending)
  const createAccountError = useStore($errorCreateAccount)

  return { accountForm, loading, createAccountError }
}
